var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashOutlineGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66602 8.00008C2.66602 7.2637 3.26297 6.66675 3.99935 6.66675H27.9993C28.7357 6.66675 29.3327 7.2637 29.3327 8.00008C29.3327 8.73646 28.7357 9.33341 27.9993 9.33341H3.99935C3.26297 9.33341 2.66602 8.73646 2.66602 8.00008Z",
    fill: "#038E83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.334 3.99992C12.9804 3.99992 12.6412 4.14039 12.3912 4.39044C12.1411 4.64049 12.0007 4.97963 12.0007 5.33325V6.66658H20.0007V5.33325C20.0007 4.97963 19.8602 4.64049 19.6101 4.39044C19.3601 4.14039 19.0209 3.99992 18.6673 3.99992H13.334ZM22.6673 6.66658V5.33325C22.6673 4.27239 22.2459 3.25497 21.4957 2.50482C20.7456 1.75468 19.7282 1.33325 18.6673 1.33325H13.334C12.2731 1.33325 11.2557 1.75468 10.5056 2.50482C9.75541 3.25497 9.33398 4.27239 9.33398 5.33325V6.66658H6.66732C5.93094 6.66658 5.33398 7.26354 5.33398 7.99992V26.6666C5.33398 27.7275 5.75541 28.7449 6.50556 29.495C7.2557 30.2452 8.27312 30.6666 9.33398 30.6666H22.6673C23.7282 30.6666 24.7456 30.2452 25.4957 29.495C26.2459 28.7449 26.6673 27.7275 26.6673 26.6666V7.99992C26.6673 7.26354 26.0704 6.66658 25.334 6.66658H22.6673ZM8.00065 9.33325V26.6666C8.00065 27.0202 8.14113 27.3593 8.39118 27.6094C8.64122 27.8594 8.98036 27.9999 9.33398 27.9999H22.6673C23.0209 27.9999 23.3601 27.8594 23.6101 27.6094C23.8602 27.3593 24.0007 27.0202 24.0007 26.6666V9.33325H8.00065Z",
    fill: "#038E83"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 13.3334C14.0697 13.3334 14.6667 13.9303 14.6667 14.6667V22.6667C14.6667 23.4031 14.0697 24 13.3333 24C12.597 24 12 23.4031 12 22.6667V14.6667C12 13.9303 12.597 13.3334 13.3333 13.3334Z",
    fill: "#038E83"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6673 13.3333C19.4037 13.3333 20.0007 13.9302 20.0007 14.6666V22.6666C20.0007 23.403 19.4037 23.9999 18.6673 23.9999C17.9309 23.9999 17.334 23.403 17.334 22.6666V14.6666C17.334 13.9302 17.9309 13.3333 18.6673 13.3333Z",
    fill: "#038E83"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashOutlineGreen);
export default __webpack_public_path__ + "static/media/trash-outline-green.9638defd.svg";
export { ForwardRef as ReactComponent };